<template>
    <div class="form-layout">

        <div class="form-rows"  style="padding-bottom:0px;">
            <div class="fields input half left" :class="{'has-error': errors.has('password_clear') }">
                <label for="password_clear">{{ locale.text_password_label}} *</label>
                <input type="password" v-validate="{ rules: { required: true,  max: 20, min: 8, password: true, confirmed: 'password_confirm' } }" name="password_clear" id="password_clear" :placeholder="locale.text_password_label" v-model="password"/>
                <p class="text-danger" v-if="errors.has('password_clear')">{{ errors.first('password_clear') }}</p>
            </div>

            <div class="fields input half right" :class="{'has-error': errors.firstByRule('password_clear', 'confirmed') != null }">
                <label for="password_confirm">{{ locale.text_confirm_password_label }} *</label>
                <input type="password" name="password_confirm" id="password_confirm" :placeholder="locale.text_confirm_password_label"/>
            </div>
        </div>

        <div class="form-rows">

            <div class="fields input half right">
                <label>&nbsp;</label>
                <input type="button" @click="handle" class="cta-button blue" :value="locale.button_request_password" />
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        data () {
            return {
                email: (this.$route.query.hasOwnProperty('email') ? this.$route.query.email : ""),
                password: "",
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.account.register;
            }
        },
        methods: {
            handle: function () {
                /**
                 * Obviously don't want to continue if there are errors.
                 */
                this.$validator.validateAll();
                if(this.errors.errors.length) {
                    $("html, body").animate({scrollTop: $(".title-bar").offset().top}, "slow");
                    return false;
                }

                /**
                 * Submitting! :)
                 */
                axios.patch('/camp-booking/users/reset-password-with-code', {
                    "user_id": this.$route.query.user_id,
                    "password_reset_code": this.$route.query.code,
                    "password_clear": this.password
                }).then(response => {
                    if(response.data.status == 'success') {
                        this.$root.alert(this.locale.text_alert_password_updated, 'success');
                        this.$router.push({ name: 'auth.login' })
                    }
                }).catch(error => {
                    if(error.response.data.status == 'unauthorised') {
                        this.$root.alert(this.locale.text_alert_password_invalid_code);

                        setTimeout(() => {
                            this.$router.push({ name: 'auth.password' });
                        }, 3500)
                    } else {
                        this.$root.alert(error.response.data.data.message || this.locale.text_alert_password_error);
                    }
                    $("html, body").animate({ scrollTop: $(".title-bar").offset().top }, "slow");
                });

            }
        },
        created () {
            if(!this.$route.query.hasOwnProperty('code') || !this.$route.query.hasOwnProperty('user_id'))
                this.$router.push({ name : 'auth.password'});
        }
    }
</script>


// WEBPACK FOOTER //
// reset.vue?4f6edd0e